//Inventory insights fallback return if statsig fails

import type { RingSizeData } from '@jouzen/ecom-components';

import { RingFinishEnum } from '@/app/enums/RingFinishEnum';

import type { StyleDepletionFallback } from '../_types/inventoryTypes';
import { OUT_OF_STOCK } from '.';

const ringSpecificSizes: RingSizeData[] = [
  {
    size: 4,
    stockStatus: OUT_OF_STOCK,
  },
  {
    size: 5,
    stockStatus: OUT_OF_STOCK,
  },
  {
    size: 6,
    stockStatus: OUT_OF_STOCK,
  },
  {
    size: 7,
    stockStatus: OUT_OF_STOCK,
  },
  {
    size: 8,
    stockStatus: OUT_OF_STOCK,
  },
  {
    size: 9,
    stockStatus: OUT_OF_STOCK,
  },
  {
    size: 10,
    stockStatus: OUT_OF_STOCK,
  },
  {
    size: 11,
    stockStatus: OUT_OF_STOCK,
  },
  {
    size: 12,
    stockStatus: OUT_OF_STOCK,
  },
  {
    size: 13,
    stockStatus: OUT_OF_STOCK,
  },
  {
    size: 14,
    stockStatus: OUT_OF_STOCK,
  },
  {
    size: 15,
    stockStatus: OUT_OF_STOCK,
  },
];

export const styleDepletionFallback: StyleDepletionFallback = {
  stockStatus: OUT_OF_STOCK,
  [RingFinishEnum.Silver]: {
    stockStatus: OUT_OF_STOCK,
    sizes: ringSpecificSizes,
  },
  [RingFinishEnum.Black]: {
    stockStatus: OUT_OF_STOCK,
    sizes: ringSpecificSizes,
  },
  [RingFinishEnum.Stealth]: {
    stockStatus: OUT_OF_STOCK,
    sizes: ringSpecificSizes,
  },
  [RingFinishEnum.Gold]: {
    stockStatus: OUT_OF_STOCK,
    sizes: ringSpecificSizes,
  },
  [RingFinishEnum.Titanium]: {
    stockStatus: OUT_OF_STOCK,
    sizes: ringSpecificSizes,
  },
  [RingFinishEnum.Rose]: {
    stockStatus: OUT_OF_STOCK,
    sizes: ringSpecificSizes,
  },
  [RingFinishEnum.RoseGold]: {
    stockStatus: OUT_OF_STOCK,
    sizes: ringSpecificSizes,
  },
  [RingFinishEnum.BrushedSilver]: {
    stockStatus: OUT_OF_STOCK,
    sizes: ringSpecificSizes,
  },
};
